import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {ToastService} from "@shared/services/toast.service";
import {CONSTANT_APIS} from "@shared/constant";

@Injectable({
  providedIn: 'root'
})
export class DashboardService {
  constructor(private http: HttpClient, private toast: ToastService) {
  }

  public getDashboardData() {
    return this.http.get(CONSTANT_APIS.DASHBOARD_DATA);
  }

  public redeem(code: string, amount: number) {
    return this.http.post('web/dashboard/redeem?code=' + code + '&amount=' + amount, {})
  }
}
